import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import { format as nf } from "../Utils/NumberFormatter";
export var IndicatorInput = function IndicatorInput() {
  _classCallCheck(this, IndicatorInput);
};
export var AllInputs = function AllInputs() {
  _classCallCheck(this, AllInputs);
};
export var Indicator =
/*#__PURE__*/
function () {
  _createClass(Indicator, null, [{
    key: "reverseInputs",
    value: function reverseInputs(input) {
      if (input.reversedInput) {
        input.values ? input.values.reverse() : undefined;
        input.open ? input.open.reverse() : undefined;
        input.high ? input.high.reverse() : undefined;
        input.low ? input.low.reverse() : undefined;
        input.close ? input.close.reverse() : undefined;
        input.volume ? input.volume.reverse() : undefined;
        input.timestamp ? input.timestamp.reverse() : undefined;
      }
    }
  }]);

  function Indicator(input) {
    _classCallCheck(this, Indicator);

    this.format = input.format || nf;
  }

  _createClass(Indicator, [{
    key: "getResult",
    value: function getResult() {
      return this.result;
    }
  }]);

  return Indicator;
}();